module.exports = {"id":"44295bbb-caf2-4f8b-b749-577060aa389f","name":"amortization-table","items":[{"type":"inline","items":[{"name":"account","type":"text-field","props":{"label":"Chart of Account Affected","required":true,"width":9}},{"name":"amount","type":"text-field","props":{"label":"Amount","format":"dollars","required":true,"width":3}},{"name":"reason","type":"textarea","props":{"label":"Discription","maxLength":250,"width":12,"required":true}}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/valuation-elite/data_table_forms/other-financials copy.json
// module id = dIJf
// module chunks = 0